export default __webpack_public_path__ + "static/media/plugged_by_driver_card_icon.327d0320.svg";